import { useQuery } from "@tanstack/react-query";
import { FinanceBookAPI } from "api";

const fetchData = (costCenterId) => {
  return FinanceBookAPI.get({ params: { costCenterId } });
};
export const useFetchFinanceBook = (costCenterId) => {
  return useQuery({
    queryKey: ["finance-book", costCenterId],
    queryFn: () => fetchData(costCenterId),
    refetchOnWindowFocus: false, // Disable refetching on window focus
  });
};
